import React from 'react'
import {UserContextProvider} from '../../context/UserContext'
import {Grid} from '@material-ui/core'
import './Wizard.scss'
import SetupWizard from './SetupWizard'
import {Alert} from '@material-ui/lab'
import {getAccountConfigurations} from './action'
import VerticalLinearStepper from './VerticalStepper'

const SetupWizardContainer = () => {
  const [systemProgress, setSystemProgress] = React.useState(0)
  const [response, setResponse] = React.useState({})
  const [apiCount, setApiCount] = React.useState(0)
  const isFinalStep = response?.progress_step === 'reports'
  const isFailed = response?.progress_step === 'failed'
  const isConfigurationDone = systemProgress === 100

  const getAccountProgress = React.useCallback(async () => {
    const {data} = await getAccountConfigurations()
    if (data) {
      setSystemProgress(data?.system_progress)
      setResponse(data)
      window.parent.postMessage(
        {key: 'CONFIGURATION_PROGRESS', value: data?.system_progress},
        process.env.REACT_APP_WIZARD_DOMAIN
      )
    }
  }, [])

  React.useEffect(() => {
    if (apiCount === 0) {
      window.parent.postMessage(
        {key: 'PROGRESS_LOADING', value: 'PROGRESS_LOADING'},
        process.env.REACT_APP_WIZARD_DOMAIN
      )
    }
    const interval = setInterval(() => {
      if (!isFinalStep && apiCount < 5) {
        getAccountProgress()
        setApiCount(apiCount => apiCount + 1)
      }

      if ((isFinalStep && isConfigurationDone) || apiCount > 4) {
        clearInterval(interval)
      }
    }, 3000)

    return () => clearInterval(interval)
    // eslint-disable-next-line
  }, [getAccountProgress, isFinalStep, apiCount])

  const [progressStep, setProgressStep] = React.useState(15)
  return (
    <UserContextProvider>
      <Grid container>
        <Grid item xs={4}>
          <div className="left-sec">
            <p className="config-steps">Configuration Steps</p>
            <VerticalLinearStepper
              setProgressStep={setProgressStep}
              isConfigurationDone
              response={response}
            />
          </div>
        </Grid>
        <Grid item xs={8}>
          {isFailed && (
            <Alert severity="error" style={{marginTop: '10px'}}>
              The account setup process has encountered an error, please contact Asset Panda support
            </Alert>
          )}
          <div className="right-sec">
            <div className="text-content">
              <SetupWizard progressStep={progressStep} />
            </div>
          </div>
        </Grid>
      </Grid>
    </UserContextProvider>
  )
}
export default SetupWizardContainer
